import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IwMenu from "../../../app/IwMenu";
import { useNavigate } from "react-router-dom";


export const actionCell = ({...props}) => {

  const {
    row,
    handleOpenAddRoleModal,
  } = {...props}
  const navigate = useNavigate();
  
  return (
    <IwMenu
      label={<MoreVertIcon fontSize="medium" />}
      tooltipProps={{
        title: "Options",
      }}
      triggerComponentSx={{
        margin: "0 8px",
        padding: "2px 0",
      }}
      items={[
        {
          id: "add-role",
          label: "Add Roles",
          onClick: () => {
            handleOpenAddRoleModal();
          },
        },
        {
          id: "go-to-details",
          label: "Go to Details",
          onClick: () => {
            navigate(`/admin/${row.original.userID}`, {
              state: { userData: row.original },
            })
          },
        },
        // {
        //   id: "move-user",
        //   label: "Move User",
        //   onClick: () => {
        //     handleOpenMoveUserModal();
        //   },
        // },
        // {
        //   id: "remove-from-cohort",
        //   label: "Remove from Cohort",
        //   onClick: () => {},
        // },
      ]}
    />
  );
};
 
